/**
 * Modal for logging/registering
 */

import { withAuthenticatedUser } from 'labstep-web/containers/AuthenticatedUser';
import { withUiPersistent } from 'labstep-web/containers/UiPersistent';
import { Redirect } from 'labstep-web/core/Redirect';
import { ForgotPassword } from 'labstep-web/screens/Authentication/ForgotPassword';
import { ResetPasswordScreenContainer as ResetPassword } from 'labstep-web/screens/Authentication/ResetPassword';
import { GetSAMLLoginUrlContainer as SAMLGetLoginUrl } from 'labstep-web/screens/Authentication/SAML/GetLoginUrl';
import { SetPasswordScreenContainer as SetPassword } from 'labstep-web/screens/Authentication/SetPassword';
import { SigninSAML } from 'labstep-web/screens/Authentication/SigninSAML';
import { navigation } from 'labstep-web/services/navigation';
import { windowService } from 'labstep-web/services/window.service';
import type React from 'react';
import { Route, Switch } from 'react-router-dom';
import SAMLAuthentication from './SAML/Authentication';
import SAMLLogin from './SAML/Login';
import SAMLLoginNew from './SAML/LoginNew';
import Signin from './Signin';
import Signup from './Signup';
import SignupEnterprise from './SignupEnterprise';
import type { IAuthenticationScreenProps } from './types';

export const AuthenticationScreen: React.FC<
  IAuthenticationScreenProps
> = ({ authenticatedUser, uiPersistent }) => {
  if (authenticatedUser.authenticated) {
    if (
      uiPersistent.active_share_link &&
      !(
        uiPersistent.active_share_link.organization &&
        authenticatedUser.is_new
      ) &&
      authenticatedUser.enabled
    ) {
      return (
        <Redirect
          to="sharelink_show"
          params={{ token: uiPersistent.active_share_link.token }}
        />
      );
    }
    return <Redirect to="app_homepage" />;
  }

  const organization = windowService.detectOrganization();
  if (organization) {
    return (
      <Switch>
        <Route
          exact
          path={navigation.get('saml_get_login_url')}
          component={SAMLGetLoginUrl}
        />
        <Route
          exact
          path={navigation.get('saml_login')}
          component={SAMLLogin}
        />
        <Route component={SAMLAuthentication} />
      </Switch>
    );
  }

  return (
    <Switch>
      <Route
        exact
        path={navigation.get('forgot_password')}
        component={ForgotPassword}
      />
      <Route
        exact
        path={navigation.get('reset_password')}
        component={ResetPassword}
      />
      <Route
        exact
        path={navigation.get('set_password')}
        component={SetPassword}
      />
      <Route
        exact
        path={navigation.get('signup')}
        component={Signup}
      />
      <Route
        exact
        path={navigation.get('login_saml')}
        component={SigninSAML}
      />
      <Route
        exact
        path={navigation.get('saml_get_login_url')}
        component={SAMLGetLoginUrl}
      />
      <Route
        exact
        path={navigation.get('saml_login_new')}
        component={SAMLLoginNew}
      />
      <Route
        exact
        path={navigation.get('signup_enterprise')}
        component={SignupEnterprise}
      />
      <Route component={Signin} />
    </Switch>
  );
};

export default withUiPersistent(
  withAuthenticatedUser(AuthenticationScreen),
);
